import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material'
import { BatchTable } from '../../../components/_WMS/ListBatch/BatchTable'
import { Batch } from '../../../interfaces/Batch'

interface BatchSelectionModalProps {
  open: boolean
  onClose: () => void
  onBatchSelect: (batch: Batch) => void
  batches: Batch[]
  sku: string
  positionCode: string
  hasBatchNumber: boolean
  hasExpirationDate: boolean
  isLoading?: boolean
  skuProductOriginDays?: number
}

export const BatchSelectionModal: React.FC<BatchSelectionModalProps> = ({
  open,
  onClose,
  onBatchSelect,
  batches,
  sku,
  positionCode,
  hasBatchNumber,
  hasExpirationDate,
  isLoading = false,
  skuProductOriginDays = 0
}) => {
  const getModalTitle = () => {
    if (hasBatchNumber && hasExpirationDate) {
      return 'Seleccionar Lote y Fecha de Expiración'
    } else if (hasBatchNumber) {
      return 'Seleccionar Lote'
    } else if (hasExpirationDate) {
      return 'Seleccionar Fecha de Expiración'
    }
    return 'Seleccionar Batch'
  }

  const getEmptyMessage = () => {
    return `No hay ${
      hasBatchNumber ? 'lotes' : 'fechas'
    } disponibles para este producto en la posición ${positionCode}`
  }

  const handleBatchClick = (batch: Batch) => {
    onBatchSelect(batch)
  }

  const handleClose = () => {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='md'
      fullWidth
        // No permitir cerrar haciendo click fuera
      disableEscapeKeyDown={true}   // No permitir cerrar con ESC
    >
      <DialogTitle>
        <Typography
          variant='h6'
          style={{ fontWeight: 'bold', color: '#1976d2' }}
        >
          {getModalTitle()}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant='body2' color='textSecondary'>
            <strong>SKU:</strong> {sku}
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            <strong>Posición:</strong> {positionCode}
          </Typography>
        </Box>

        <Box mt={2}>
          {batches.length > 0 ? (
            <Typography
              variant='body2'
              style={{ marginBottom: '16px', color: '#666' }}
            >
              Seleccione el {hasBatchNumber ? 'lote' : 'batch'} que desea
              reubicar:
            </Typography>
          ) : null}

          <BatchTable
            batches={batches}
            showBatchNumber={hasBatchNumber}
            showExpirationDate={hasExpirationDate}
            showQuantity={true}
            isLoading={isLoading}
            emptyText={getEmptyMessage()}
            onBatchClick={handleBatchClick}
            skuProductOriginDays={skuProductOriginDays}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color='secondary' disabled={isLoading}>
          Cancelar
        </Button>
        <Typography variant='caption' style={{ color: '#666', marginRight: 'auto', paddingLeft: 16 }}>
          Debe seleccionar un lote para continuar
        </Typography>
      </DialogActions>
    </Dialog>
  )
}

